// @flow
import React, { Component } from 'react';
import { isBrowser } from 'react-device-detect';
import type { ProfileLinks } from 'store/modules/settings';
import Button from 'components/common/Button';
import './SettingProfileLinks.scss';
import SettingProfileLink from '../SettingProfileLink';

type Props = {
  profileLinks: ?ProfileLinks,
  onUpdate: (profileLinks: ProfileLinks) => Promise<any>,
};
type State = {
  email: string,
  linkedin: string,
  twitter: string,
  facebook: string,
  url: string,
};

class SettingProfileLinks extends Component<Props, State> {
  state = {
    email: '',
    linkedin: '',
    twitter: '',
    facebook: '',
    url: '',
  };

  feedInputs = () => {
    const { profileLinks } = this.props;
    if (!profileLinks) return;
    const keys = Object.keys(profileLinks);
    const nextState = {};
    keys.forEach(key => {
      nextState[key] = profileLinks[key] || '';
    });
    this.setState(nextState);
  };

  componentDidMount() {
    this.feedInputs();
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.profileLinks !== this.props.profileLinks) {
      this.feedInputs();
    }
  }

  onChange = (e: SyntheticInputEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    this.setState({
      [name]: value,
    });
  };

  onUpdate = () => {
    const { email, linkedin, twitter, facebook, url } = this.state;
    this.props.onUpdate({
      email,
      linkedin,
      twitter,
      facebook,
      url,
    });
  };

  render() {
    const { email, linkedin, twitter, facebook, url } = this.state;
    return (
      <section className="SettingProfileLinks">
        <p>여기에 입력하는 정보는 마이페이지에서 나타나게 됩니다.</p>
        <div className="inputs">
          <SettingProfileLink label="이메일" name="email" value={email} onChange={this.onChange} />
          <SettingProfileLink label="홈페이지" name="url" value={url} onChange={this.onChange} />
        </div>
        <div className="button-wrapper">
          <Button large onClick={this.onUpdate} desktop={isBrowser}>
            저장
          </Button>
        </div>
      </section>
    );
  }
}

export default SettingProfileLinks;



// WEBPACK FOOTER //
// ./src/components/settings/SettingProfileLinks/SettingProfileLinks.js